var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9826_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6349 0.39668C11.1273 0.921231 11.1205 1.76585 10.6213 2.2824L5.71983 7.35631C5.31201 7.78485 4.77304 8 4.23323 8C3.69341 8 3.14852 7.78307 2.73477 7.3492L0.385981 4.9576C-0.117453 4.44461 -0.130144 3.60089 0.358059 3.07189C0.847108 2.54289 1.64922 2.53045 2.15265 3.04255L4.22815 5.15676L8.83943 0.383345C9.33863 -0.134094 10.1441 -0.126092 10.634 0.397569L10.6349 0.39668Z",
    fill: "#525254"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9826_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/check-grey.4ef9311107fd6e3569b793e5eb521b21.svg";
export { ForwardRef as ReactComponent };